import { useId, useState, type ReactNode } from 'react';

export function ExpandableSection({ title, eyebrow, description, className = '', children }: {
  title: string; eyebrow?: string; description?: string; className?: string; children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const contentId = useId();
  return <article className={`admin-card admin-collapsible ${className}${open ? ' open' : ''}`}>
    <header role="button" tabIndex={0} aria-expanded={open} aria-controls={contentId}
      onClick={() => setOpen(!open)} onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); setOpen(!open); }
      }}>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}<h2>{title}</h2>
      {description && <p>{description}</p>}
    </header>
    <div id={contentId} hidden={!open}>{children}</div>
  </article>;
}
